import type { InputHTMLAttributes } from 'react';
import { css, cva, type RecipeVariantProps } from '../../styled-system/css';
import { Stack } from '../../styled-system/jsx';
import { Label } from './Label';
import { SystemStyleObject } from '../../styled-system/types';

export const inputRecipe = cva({
  base: {
    fontSize: 'sm',
    color: 'main.text.2',
    background: 'transparent',
    outline: 'none',
    width: '100%',
    padding: '4',
    rounded: 'lg',
    border: '1px solid',
    bg: 'main.background.1',
    borderColor: 'main.border.1',

    _file: {
      bg: 'main.interactive.2',
      px: '4',
      py: '2',
      marginEnd: '3',
      rounded: 'lg',
      border: '1px solid',
      borderColor: 'main.border.1',
    },

    _focus: {
      borderColor: 'main.solid.1',
    }
  },
  variants: {
    inputSize: {
      sm: {
        fontSize: 'xs',
        height: '10',
        padding: '2',
        maxWidth: '100px',
      },
      md: {
        fontSize: 'sm',
        padding: '4',
      }
    }
  },
  defaultVariants: {
    inputSize: 'md',
  }
});

type InputVariants = RecipeVariantProps<typeof inputRecipe>;

export const Input = ({
  children,
  label = '',
  inputSize = 'md',
  css: cssProp,
  ...props
}: InputHTMLAttributes<HTMLInputElement> & InputVariants & { label?: string; css?: SystemStyleObject; }) => {
  if (label) {
    return (
      <Stack gap={2}>
        <Label
          htmlFor={props.id}
          size={inputSize}
        >
          {label}
        </Label>
        <input {...props} className={css(inputRecipe.raw({ inputSize }), cssProp)} />
      </Stack>
    );
  }

  return (
    <input
      {...props}
      className={css(inputRecipe.raw({ inputSize }), cssProp)}
    >
      {children}
    </input>
  );
};
